export enum ErrorDeliveryTarget {
  Page = 'Page',
  ModalAlert = 'ModalAlert',
  None = 'None',
}

export class ErrorDelivery<T = unknown> {
  public target: ErrorDeliveryTarget;
  private error: T;
  private flowEnded = false;

  public constructor(error: T, target: ErrorDeliveryTarget = ErrorDeliveryTarget.None) {
    this.error = error;
    this.target = target;
  }

  public static is(error: unknown, target?: ErrorDeliveryTarget): boolean {
    return error instanceof ErrorDelivery && (target ? (error as ErrorDelivery).target === target : true);
  }

  public static from<P = unknown>(error: P, target: ErrorDeliveryTarget = ErrorDeliveryTarget.None): ErrorDelivery<P> {
    return new ErrorDelivery<P>(ErrorDelivery.is(error) ? (error as unknown as ErrorDelivery<P>).getRawError() : error, target);
  }

  public getRawError<A extends T>(transform?: (error: A) => Partial<A>): A {
    return { ...this.error, ...(transform ? transform(this.error as A) : {}) } as unknown as A;
  }

  public isErrorPage(): boolean {
    return ErrorDelivery.is(this, ErrorDeliveryTarget.Page);
  }

  public isModalAlert(): boolean {
    return ErrorDelivery.is(this, ErrorDeliveryTarget.ModalAlert);
  }

  public hasNoTarget(): boolean {
    return ErrorDelivery.is(this, ErrorDeliveryTarget.None);
  }

  public endingTheFlow(): this {
    this.flowEnded = true;
    return this;
  }

  public endsFlow(): boolean {
    return this.flowEnded;
  }
}

export const isAlreadyShownToUser = (error: unknown): boolean => error instanceof ErrorDelivery;

export const endsTheFlow = (error: unknown): boolean => error instanceof ErrorDelivery && error.endsFlow();
